import styled from "styled-components";

export const InputContainer = styled.div`
    background-color: #FFF;
    width: auto;
    min-width: 500px;
    max-width: 100%;
    height: 60px;
    border-radius: 25px;
    box-shadow: 1px 2px 5px 1px rgba(29, 33, 41, 0.4);
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    box-sizing: border-box;
    margin-top: 0px;

    .search-button{
        padding: 20px 5px;
        margin-right: 10px;
        cursor: pointer;
        flex-shrink: 0;

    }

    input{
        border: none;
        box-sizing: border-box;
        flex: 1 1 auto;
        min-width: ${props => (props.estado ? "150px" : "180px")};
        max-width: ${props => (props.estado ? "170px" : "190px")};
        height: 60px;
        margin-left: 25px;
    }

    label{
        width: 94px;
        height: 11px;
        font-family: Lato;
        font-size: 9px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: 0.5px;
        text-align: right;
        color: #303848;
        margin-top: 25px;
    }
    img{
        width: 16px;
        height: 16px;
        margin-top: -7px;
        margin-right: 15px;
    }

    select{
        border: none;
        font-family: Lato;
        font-size: 9px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: 0.5px;
        text-align: right;
        color: #303848;
        margin-right: 5px;
        flex-shrink: 0;
        max-width: 150px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;

    }

    @media only screen and (max-width: 768px) {
        width: 100%;
        min-width: 0;
        max-width: 500px;
        flex-wrap: wrap;

        input{
            border: none;
            box-sizing: border-box;
            flex: 1 1 auto;
            width: auto;
            height: 60px;
            max-width: 400px;
        }

        label{
            width: 100%;
            max-width: 94px;
            height: 11px;
            font-family: Lato;
            font-size: 9px;
            font-weight: normal;
            font-stretch: normal;
            font-style: normal;
            line-height: normal;
            letter-spacing: 0.5px;
            text-align: right;
            color: #303848;
            margin-top: 25px;
        }
        img{
            width: 16px;
            height: 16px;
            margin-top: -7px;
            margin-right: 15px;
        }

        select{
            border: none;
            font-family: Lato;
            font-size: 9px;
            font-weight: normal;
            font-stretch: normal;
            font-style: normal;
            line-height: normal;
            letter-spacing: 0.5px;
            text-align: right;
            color: #303848;
            margin-right: 5px;
            flex-shrink: 0;
            max-width: 110px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }
    }
`;
